import React from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@material-ui/icons/Add';
import { IconButton } from '@mui';

const AddButton = ({ onClick, tooltip, style = {} }) => (
  <IconButton onClick={onClick} style={{ padding: 0, ...style }} aria-label={tooltip || 'Add'} tooltip={tooltip}>
    <AddIcon />
  </IconButton>
);

AddButton.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  tooltip: PropTypes.string
};

export default AddButton;
